/** Shared SweetAlert2 Bootstrap styling presets. */

export const SWAL_BASE = { buttonsStyling: false };

const ALERT_TEXT_MAX_LENGTH = 500;

function clipAlertText(value) {
    if (typeof value !== "string") {
        return "";
    }
    return value.slice(0, ALERT_TEXT_MAX_LENGTH);
}

/** Copy only title/text from untrusted alert configs. Never forward html. */
export function allowlistedSwalAlert(source) {
    if (!source || typeof source !== "object") {
        return null;
    }
    const title = clipAlertText(source.title);
    const text = clipAlertText(source.text);
    if (!title && !text) {
        return null;
    }
    return { title, text };
}

export const SWAL_CLASSES = {
    ok: {
        confirmButton: "btn btn-primary"
    },
    okLight: {
        confirmButton: "btn btn-light",
    },
    dangerOk: {
        confirmButton: "btn btn-danger",
    },
    confirmCancel: {
        confirmButton: "btn btn-primary me-2",
        cancelButton: "btn btn-outline-secondary",
    },
    confirmCancelLight: {
        confirmButton: "btn btn-primary me-2",
        cancelButton: "btn btn-light",
    },
    destructive: {
        confirmButton: "btn btn-danger me-2",
        cancelButton: "btn btn-outline-secondary",
    },
    precheck: {
        confirmButton: "btn btn-danger",
        denyButton: "btn btn-light mx-2",
        cancelButton: "btn btn-outline-secondary",
    },
    trial: {
        confirmButton: "btn btn-primary me-2",
        denyButton: "btn btn-outline-secondary",
    },
    confirmDenyCancel: {
        confirmButton: "btn btn-primary me-2",
        denyButton: "btn btn-light me-2",
        cancelButton: "btn btn-outline-secondary",
    },
    denyCancel: {
        confirmButton: "btn btn-lg btn-primary me-2",
        denyButton: "btn btn-lg btn-outline-secondary",
    },
    destructiveDeny: {
        confirmButton: "btn btn-lg btn-danger me-2",
        denyButton: "btn btn-lg btn-outline-secondary",
    },
};
